import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=3be9b658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be9b658"]])

export default __exports__